import React from "react";
import { BookOpen, BarChart3, Coins } from "lucide-react";

const ResearchSection = () => {
  const researchCards = [
    {
      icon: BookOpen,
      title: "Halal Stock Shortlists",
      description: "Curated lists of Shariah-compliant stocks in US & Pakistan with basic screening notes and compliance ratios.",
    },
    {
      icon: BarChart3,
      title: "Deep-Dive Write-Ups",
      description: "Long-form research pieces with thesis, risks, and valuation analysis — similar to professional investment research.",
    },
    {
      icon: Coins,
      title: "Commodities & Macro Notes",
      description: "Periodic notes on commodities (gold, oil) and how they fit into a Shariah-compliant portfolio strategy.",
    },
  ];

  return (
    <section
      id="research"
      data-testid="research-section"
      className="py-20 md:py-32 bg-ics-navy"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="section-divider mx-auto" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-4">
            Research, Screens, and Case Studies
          </h2>
          <p className="text-ics-gray max-w-2xl mx-auto">
            Our community produces and shares various types of investment research, 
            all viewed through a Shariah-compliance lens.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {researchCards.map((card, index) => (
            <div
              key={index}
              data-testid={`research-card-${index}`}
              className="glass-card feature-card rounded-2xl p-8 hover-lift"
            >
              <div className="feature-icon mb-6">
                <card.icon className="w-7 h-7" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-ics-white mb-3">
                {card.title}
              </h3>
              <p className="text-ics-gray text-sm leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-ics-gray mt-12 max-w-2xl mx-auto">
          All content is educational research and personal opinion only. 
          ICS does not provide investment advice or recommendations.
        </p>
      </div>
    </section>
  );
};

export default ResearchSection;
